import {reactive} from "@vue/composition-api"

interface OnboardingExchangeBus {
    active: boolean
}

const onboardingExchangeBus: OnboardingExchangeBus = reactive<OnboardingExchangeBus>({
    active: false
})

export function useOnboardingExchangeBus(): OnboardingExchangeBus {
    return onboardingExchangeBus
}